import { createApp } from 'vue'
import App from './App.vue'
import { createI18n } from 'vue-i18n'
import { messages } from '@/utils/languages';

const i18n = createI18n({
    locale: 'es',
    fallbackLocale: 'en',
    messages
  })

import '@/style.css'

const app = createApp(App)
app.use(i18n)
app.mount('#app')
